import { Frontend } from "../../../../src/components/skillcats/frontend";
import { Backend } from "../../../../src/components/skillcats/backend";
import { DevAndXtra } from "../../../../src/components/skillcats/devsandext.tsx";
import * as React from 'react';
export default {
  Frontend,
  Backend,
  DevAndXtra,
  React
};